import { render, staticRenderFns } from "./LegacyPlatformNotice.vue?vue&type=template&id=5fa6300f&scoped=true"
import script from "./LegacyPlatformNotice.vue?vue&type=script&lang=js"
export * from "./LegacyPlatformNotice.vue?vue&type=script&lang=js"
import style0 from "./LegacyPlatformNotice.vue?vue&type=style&index=0&id=5fa6300f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa6300f",
  null
  
)

export default component.exports